export default "__VITE_ASSET__BGVXencD__"